import { stripLocalePrefix } from "./i18n-locale-routes";

/** 未登录/登录失效时不强制跳转首页的路由前缀（公开落地页） */
export const AUTH_REDIRECT_EXEMPT_PREFIXES = [
	"/seer/corporate-center",
	"/seer/mentor-join",
	"/seer/creator-join",
];

export function isAuthRedirectExemptPath(path) {
	if (!path) return false;
	const normalized = stripLocalePrefix(path);
	return AUTH_REDIRECT_EXEMPT_PREFIXES.some(
		prefix => normalized === prefix || normalized.startsWith(`${prefix}/`)
	);
}
